import * as React from "react"
import {GlobalStyles} from "@mui/material";

import {dsColorNew} from "@palette";


export default function StandaloneStyles() {
	return <GlobalStyles styles={{
		body: {
			background: `linear-gradient(135deg, ${dsColorNew.loginGrad1} 0%, ${dsColorNew.loginGrad2} 35%, ${dsColorNew.loginGrad3} 70%, ${dsColorNew.loginGrad4} 100%)`,
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			height: '100vh'
		}
	}} />
}
